import { render, staticRenderFns } from "./DocumentSearch.vue?vue&type=template&id=8622a424&scoped=true&"
import script from "./DocumentSearch.vue?vue&type=script&lang=ts&"
export * from "./DocumentSearch.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentSearch.vue?vue&type=style&index=0&id=8622a424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8622a424",
  null
  
)

export default component.exports